'use client'

/** Página personalizada de erros para client. */
export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
    console.apm(error)

    const styles: any = {
        section: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            height: '765px',
            gap: '9px',
            padding: '0 18px'
        },
        svgContainer: {
            width: '135px',
            height: '135px',
            flexShrink: '0'
        },
        svg: {
            width: '100%',
            height: '100%'
        },
        heading: {
            textAlign: 'center'
        },
        paragraph: {
            textAlign: 'center'
        },
        link: {
            color: 'white',
            fontWeight: '500',
            padding: '18px 36px',
            backgroundColor: 'var(--primary-color)',
            borderRadius: '4.5px',
            marginTop: '27px',
            cursor: 'pointer'
        }
    }

    return (
        <section style={styles.section}>
            <div style={styles.svgContainer}>
                <svg fill="var(--text-color)" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g><path d="M520.741 163.801a10.234 10.234 0 00-3.406-3.406c-4.827-2.946-11.129-1.421-14.075 3.406L80.258 856.874a10.236 10.236 0 00-1.499 5.335c0 5.655 4.585 10.24 10.24 10.24h846.004c1.882 0 3.728-.519 5.335-1.499 4.827-2.946 6.352-9.248 3.406-14.075L520.742 163.802zm43.703-26.674L987.446 830.2c17.678 28.964 8.528 66.774-20.436 84.452a61.445 61.445 0 01-32.008 8.996H88.998c-33.932 0-61.44-27.508-61.44-61.44a61.445 61.445 0 018.996-32.008l423.002-693.073c17.678-28.964 55.488-38.113 84.452-20.436a61.438 61.438 0 0120.436 20.436zM512 778.24c22.622 0 40.96-18.338 40.96-40.96s-18.338-40.96-40.96-40.96-40.96 18.338-40.96 40.96 18.338 40.96 40.96 40.96zm0-440.32c-22.622 0-40.96 18.338-40.96 40.96v225.28c0 22.622 18.338 40.96 40.96 40.96s40.96-18.338 40.96-40.96V378.88c0-22.622-18.338-40.96-40.96-40.96z"></path></g></svg>
            </div>
            <h1 className='font-xxlg' style={styles.heading}>Oops!</h1>
            <p className='font-xmd' style={styles.paragraph}>Tivemos um problema por aqui. Por favor, tente novamente mais tarde.</p>
            <small>{error.message}</small>
            <span onClick={() => reset()} className='font-md' style={styles.link} >Tentar novamente</span>
        </section>
    )
}  